export default "__VITE_ASSET__DZo_r$3g__"